import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { HorizontalConnectionPos, VerticalConnectionPos } from '@angular/cdk/overlay';

@Component({
  selector: 'app-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class DropdownButtonComponent {
  @Input() leaveModalOpen: boolean = false;
  @Input() originX: HorizontalConnectionPos = 'end';
  @Input() originY: VerticalConnectionPos = 'bottom';
  @Input() overlayX: HorizontalConnectionPos = 'end';
  @Input() overlayY: VerticalConnectionPos = 'top';

  @Output() infoButtonClicked = new EventEmitter<void>();

  emitirClick(): void {
    this.infoButtonClicked.emit();
  }

}
